import React from "react";
import { Link } from "react-router-dom";
import Header from "@/component/header";
import Footer from "@/component/footer";
import mainBg from "@public/img/main-bg.svg";
import "@/styles/platform-notice.css";

type PlatformOnlyNoticeProps = {
  title: string;
  icon: string;
  iconAlt?: string;
};

export default function PlatformOnlyNotice({ title, icon, iconAlt }: PlatformOnlyNoticeProps) {
  return (
    <div className="platform-only-page">
      <img src={mainBg} alt="" className="platform-only-page__bg" />

      <div className="platform-only-page__header">
        <Header />
      </div>

      <div className="platform-only-page__main" role="main">
        <div className="platform-only-page__main-inner">
          <div className="platform-notice">
            <img src={icon} alt={iconAlt ? iconAlt : title} className="platform-notice__icon" />
            <h1 className="platform-notice__title">{title}</h1>
            <p className="platform-notice__text">
              این بخش در نسخه وب قابل استفاده نیست.
              <br />
              برای دسترسی، از{" "}
              <span className="platform-notice__highlight">اپلیکیشن موبایل</span>
              {" "}یا{" "}
              <span className="platform-notice__highlight">نسخه دسکتاپ</span>
              {" "}WONMOV استفاده کنید.
            </p>
            <div className="platform-notice__actions">
              <Link to="/" className="platform-notice__btn">
                بازگشت به صفحه اصلی
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="platform-only-page__footer">
        <Footer />
      </div>
    </div>
  );
}
